// F1 App-Shell (TES-948): geteilte, atomare Nav-Bausteine.
// Kapselt die wiederkehrenden `collapsed`/`!collapsed`-Verzweigungen (Icon-Center,
// Label-Sichtbarkeit, Tooltip-Wrapper) in winzige Praesentations-Komponenten.
// So bleibt jede konsumierende Funktion (SideNavItem/NavLinkBase/...) unter der
// fallow-CRAP-Schwelle, ohne Verhalten oder Markup zu aendern.
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import type { NavItem } from "./navConfig";

// Icon mit optionaler collapsed-Zentrierung (mx-auto).
export function NavIcon({ item, collapsed = false }: { item: NavItem; collapsed?: boolean }) {
  const Icon = item.icon;
  return <Icon className={cn("h-5 w-5 flex-shrink-0", collapsed && "mx-auto")} />;
}

// Label, das nur sichtbar ist, wenn nicht eingeklappt.
export function NavLabel({
  children,
  hidden = false,
  className,
}: {
  children: ReactNode;
  hidden?: boolean;
  className?: string;
}) {
  if (hidden) return null;
  return <span className={cn("font-medium", className)}>{children}</span>;
}

// Tooltip-Wrapper: side haengt am collapsed-Zustand (rechts vs. unten).
export function NavTooltip({
  collapsed,
  text,
  children,
}: {
  collapsed: boolean;
  text: ReactNode;
  children: ReactNode;
}) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={collapsed ? "right" : "bottom"}>{text}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
